import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { handleCatchError } from 'utils/CatchHandler';
import { biometricDevicesApi } from 'utils/API/Merchant APIs/AepsApiCalls';
import { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';
import { Alert } from 'antd';
import Spinner from '../LoadingSinner';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
// eslint-disable-next-line
export default function BiometricDevices({ onDeviceSelect, service }) {
    const [open, setOpen] = React.useState(false);
    const [devices, setDevices] = useState([]);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const agentid = localStorage.getItem('id');
    const navigate = useNavigate();
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') return;
        setOpen(false);
    };

    const handleDeviceClick = (device) => {
        onDeviceSelect(device.deviceName);
        handleClose();
    };

    const fetchUpdateState = async () => {
        setLoading(true);
        const payload = { agentid };
        try {
            const response = await biometricDevicesApi(payload);
            setDevices(response?.data?.data);
            if (response?.data?.status === false) {
                setMessage(response?.data?.message);
                // navigate('/merchant-home');
            }
            setLoading(false);
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        handleClickOpen();
        fetchUpdateState();
        // eslint-disable-next-line
    }, []);

    const handleHome = () => {
        if (service === 'AEPS') {
            handleClose();
        } else {
            navigate('/merchant-home');
        }
    };
    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: { maxHeight: '80vh', overflowY: 'auto' }
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px' }}>
                    {!message ? (
                        <Typography variant="h6" align="center" sx={{ fontWeight: 'bold', flexGrow: 1 }}>
                            Choose Device to Connect
                        </Typography>
                    ) : (
                        <div style={{ width: '500px', marginLeft: '100px', marginTop: '10px' }}>
                            <Alert message={message} type="warning" showIcon />
                        </div>
                    )}
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {service === 'AEPS' ? (
                            <IconButton onClick={handleHome}>
                                <span style={{ fontSize: '1.2rem' }}>✖</span>
                            </IconButton>
                        ) : (
                            <IconButton color="primary" onClick={handleHome}>
                                <HomeIcon />
                            </IconButton>
                        )}
                    </div>
                </div>
                <Grid container spacing={2} padding={2} justifyContent="center">
                    {devices?.map((device) => (
                        <Grid item xs={6} sm={4} md={3} lg={2} key={device?.id}>
                            <Card
                                sx={{
                                    maxWidth: 150,
                                    minWidth: 120,
                                    maxHeight: 180,
                                    minHeight: 160,
                                    boxShadow: 3,
                                    p: 1,
                                    ':hover': {
                                        boxShadow: 8,
                                        cursor: 'pointer'
                                    }
                                }}
                                onClick={() => handleDeviceClick(device)}
                            >
                                <Tooltip title={device?.deviceFullname} arrow>
                                    <CardContent style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 10 }}>
                                        <CardMedia
                                            component="img"
                                            height="80"
                                            image={device?.image}
                                            alt={device?.deviceName}
                                            style={{ objectFit: 'contain' }}
                                        />
                                        <Typography align="center" sx={{ fontSize: 12, marginTop: 1 }} color="text.secondary">
                                            {device?.deviceName}
                                        </Typography>
                                    </CardContent>
                                </Tooltip>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Spinner loading={loading} />
            </Dialog>
        </React.Fragment>
    );
}
